<template>
  <path
    d="M21 3.00024H3C1.9 3.00024 1 3.90024 1 5.00024V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00024C23 3.90024 22.1 3.00024 21 3.00024ZM20 19.0002H4C3.45 19.0002 3 18.5502 3 18.0002V6.00024C3 5.45024 3.45 5.00024 4 5.00024H13V8.00024C13 8.55024 13.45 9.00024 14 9.00024H21V18.0002C21 18.5502 20.55 19.0002 20 19.0002Z"
  />
</template>
